import React from 'react';
import ReactDOM from 'react-dom/client';
// No need to import useState here

import './index.css';
import App from './App';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import config from './config/config.json';

import global_en from './translation/en/global.json';
import global_es from './translation/es/global.json';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';

// --- THIS IS THE PAYPAL CONFIGURATION ---
const initialOptions = {
    clientId: config.paypal.clientId,
    currency: "USD",
    intent: "capture",
};
// --- END OF PAYPAL CONFIGURATION ---

i18next.init({
  interpolation:{escapeValue: false},
  lng: "en",
  resources: {
    en: {
      global: global_en
    },
    es: {
      global: global_es
    }
  }
}).then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    // --- THIS IS THE CORRECT WRAPPING ORDER ---
    <React.StrictMode>
      <PayPalScriptProvider options={initialOptions}>
        <I18nextProvider i18n={i18next}>
          <App />
        </I18nextProvider> 
      </PayPalScriptProvider>
    </React.StrictMode>
    // --- END OF CORRECTION ---
  );
});